import {
  ADD_IMAGES_TO_MAP,
  CLEAR_IMAGE_MAP
} from "./actionTypes"

const INIT_STATE = {};

const imageMapReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case ADD_IMAGES_TO_MAP:
      return {
        ...state,
        ...action.payload // { filename1: url1, filename2: url2, ... }
      };
    case CLEAR_IMAGE_MAP:
      return INIT_STATE;
    default:
      return state;
  }
};

export default imageMapReducer;




